import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  NotificationListQuerySchema,
  NotificationListResponseSchema,
  UnreadCountResponseSchema,
  MarkReadResponseSchema,
} from '../schemas/notifications.js';

const NotificationIdSchema = z.coerce.number().int().positive();

export const notifications = {
  list: endpoint(
    'GET',
    '/notifications',
    NotificationListQuerySchema,
    NotificationListResponseSchema,
  ),
  unreadCount: endpoint('GET', '/notifications/unread-count', z.void(), UnreadCountResponseSchema),
  markRead: endpoint(
    'PATCH',
    '/notifications/:id/read',
    z.object({ id: NotificationIdSchema }),
    MarkReadResponseSchema,
  ),
  markAllRead: endpoint('PATCH', '/notifications/read-all', z.void(), MarkReadResponseSchema),
};
